class ProcessingTargetGroupAnalysis {}

export default ProcessingTargetGroupAnalysis
